// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiArray from "lumi-array/lib/es6/src/LumiArray.res.js";
import * as V4$Linear from "./V4.res.js";
import * as V2f$Linear from "./V2f.res.js";
import * as Stdlib_List from "@rescript/runtime/lib/es6/Stdlib_List.js";
import * as Rectf$Linear from "./Rectf.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Belt_SortArray from "@rescript/runtime/lib/es6/Belt_SortArray.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";

function sortOn(xs, f) {
  return Belt_SortArray.stableSortBy(xs, (a, b) => Primitive_object.compare(f(a), f(b)));
}

function chain(points) {
  let clockwise = (o, a, b) => V2f$Linear.crossZ(V2f$Linear.minus(a, o), V2f$Linear.minus(b, o)) <= 0;
  let go = (_acc, _todo) => {
    while (true) {
      let todo = _todo;
      let acc = _acc;
      if (acc !== 0) {
        let match = acc.tl;
        if (match !== 0 && todo !== 0) {
          let x = todo.hd;
          let r2 = match.hd;
          if (clockwise(r2, acc.hd, x)) {
            _acc = {
              hd: r2,
              tl: match.tl
            };
            continue;
          }
          _todo = todo.tl;
          _acc = {
            hd: x,
            tl: acc
          };
          continue;
        }
      }
      if (todo === 0) {
        return Stdlib_List.reverse(Stdlib_Option.getOr(Stdlib_List.tail(acc), /* [] */0));
      }
      _todo = todo.tl;
      _acc = {
        hd: todo.hd,
        tl: acc
      };
      continue;
    };
  };
  return Stdlib_List.toArray(go(/* [] */0, Stdlib_List.fromArray(points)));
}

function convexHull(points) {
  let len = points.length;
  if (len === 1) {
    return [points[0]];
  }
  if (len === 0) {
    return [];
  }
  let sorted = Belt_SortArray.stableSortBy(points, Primitive_object.compare);
  let lower = chain(sorted);
  let upper = chain(sorted.toReversed());
  return lower.concat(upper);
}

function axisAlignedBoundingBox(points) {
  let xs = points.map(prim => prim[0]);
  let ys = points.map(prim => prim[1]);
  let min_0 = Math.min(...xs);
  let min_1 = Math.min(...ys);
  let min = [
    min_0,
    min_1
  ];
  let max_0 = Math.max(...xs);
  let max_1 = Math.max(...ys);
  let max = [
    max_0,
    max_1
  ];
  return {
    pos: min,
    size: V2f$Linear.minus(max, min)
  };
}

function orientedMinimumBoundingBox(points) {
  let hullPoints = convexHull(points);
  let hullEdges = LumiArray.adjacentPairs(hullPoints).filter(param => Primitive_object.notequal(param[0], param[1]));
  if (hullEdges.length === 0) {
    return;
  }
  let edgeAlignments = hullEdges.map(param => {
    let angle = V2f$Linear.angle([
      1,
      0
    ], V2f$Linear.minus(param[1], param[0]));
    return [
      angle,
      points.map(__x => V2f$Linear.rotate(__x, angle))
    ];
  });
  let edgeBoxes = edgeAlignments.map(param => [
    param[0],
    axisAlignedBoundingBox(param[1])
  ]);
  return sortOn(edgeBoxes, param => param[1].size)[0];
}

function orientedBoundingBoxPoints(param) {
  let angle = param[0];
  return V4$Linear.map(Rectf$Linear.points(param[1]), __x => V2f$Linear.rotate(__x, -1 * angle));
}

export {
  sortOn,
  chain,
  convexHull,
  axisAlignedBoundingBox,
  orientedMinimumBoundingBox,
  orientedBoundingBoxPoints,
}
/* V2f-Linear Not a pure module */
